import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWire = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#403d47",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 5H12.5V7.5C12.5 8.88071 11.3807 10 10 10C8.61929 10 7.5 8.88071 7.5 7.5V5Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 7V9.75C3.5 11.5449 4.95507 13 6.75 13H7C8.65685 13 10 11.6569 10 10V10",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.5,
			y: 2,
			width: 2,
			height: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.5,
			y: 2,
			width: 2,
			height: 2,
			fill: "currentColor"
		})
	]
});
export default SvgWire;
